module.exports = __webpack_public_path__ + "img/edit-profile.9a15dc6b.svg";